import React from "react";

// /document-api?i=refund-policy
export default function RefundPolicy() {
  return (
    <>
  <h5 className="fw-bold">1. Purpose</h5>
  <p>
    This Refund Policy is established to define the principles,
    procedures, and conditions for providing refunds to SwiftGold
    Pay customers/users. The purpose is to ensure transparency,
    clarify customer rights, minimize potential disputes, and comply
    with applicable laws and regulations.
  </p>

  <h5 className="fw-bold">2. Refund Conditions</h5>
  <p>
    SwiftGold Pay will consider refund requests under the following
    circumstances:
  </p>
  <ul>
    <li>
      Transactions resulting from system errors, such as duplicate
      charges or technical failures.
    </li>
    <li>
      Transactions where goods/services were not delivered as
      advertised (only after verification that the provider/partner
      is unable to deliver).
    </li>
    <li>
      Transactions canceled within the specified time frame
      (depending on the type of service or promotional terms).
    </li>
    <li>
      Other cases deemed appropriate and in the best interest of the
      customer at the company's discretion.
    </li>
  </ul>

  <h5 className="fw-bold">3. Non-Refundable Cases</h5>
  <p>Refunds will not be granted in the following cases:</p>
  <ul>
    <li>
      The customer provides incorrect or incomplete information
      (e.g., account number, wallet ID, recipient name).
    </li>
    <li>Transactions related to fraudulent activities or scams.</li>
  </ul>

  <h5 className="fw-bold">4. Fees</h5>
  <p>
    SwiftGold Pay may apply <b>transaction fees and/or processing
    fees</b> in connection with both deposits and refund transactions.
  </p>
  <p>
    Unless otherwise required by applicable law or in cases where the
    error is directly caused by SwiftGold Pay’s system, such fees shall
    be borne by the customer. By using the service, the customer
    acknowledges and agrees that these fees may be deducted from the
    refunded amount or charged separately, as applicable.
  </p>

  <h5 className="fw-bold">5. Disclaimer</h5>
  <ul>
    <li>
      SwiftGold Pay reserves the right to amend, modify, or update
      this Refund Policy at any time without prior notice.
    </li>
    <li>
      The company’s decision regarding refund matters shall be
      considered final, subject to applicable laws and regulations.
    </li>
  </ul>
    </>
  );
}
